import { PlessResponderSub } from './../../../kymw00/pless-responder-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * NGワードチェック
 *
 * @export API通信成功時の処理
 * @class CheckNgWordsService
 * @extends {PlessResponder}
 */
@Injectable()
export class CheckNgWordsService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: any;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckNgWordsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ItemName: this.vo.itemName,
        String: this.vo.string
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {CodeComboBoxModel} model
   * @param {string} codeDiv
   * @param {string} reserveNum1
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof CheckNgWordsService
   */
  execute(model: any, vo: any, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW02checkNgWords', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof CheckNgWordsService
   */
  success(_: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
